import logo from './logo.svg';
import './App.css';
import './custom.css';


import { BrowserRouter, Routes, Route } from "react-router";
import Dashboard from './pages/dashboard';
import {Adminroutes,Clientroutes,Authroutes} from './routes'; 
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 

function App() {
  ModuleRegistry.registerModules([AllCommunityModule]);
  const token = localStorage.getItem('token'); 
  const userdata = JSON.parse(localStorage.getItem('userdata')); 
  var system = null;
  if(userdata != undefined){
      system = userdata.usertype;   
  }else{
      system = null;   
  }
  
  
  if(token == undefined || token == ''){
    return (
      <>
         <Authroutes/>
      </>
    );      
  }else {
    console.log(system);
    if(system == 'internal'){
      return (
        <>
            <Adminroutes/>
           {/* <Authlayout children={<Login/>}/> */}
        </>
      );     
    }else if(system == 'external'){
      return (
        <>
            <Clientroutes/>
           {/* <Authlayout children={<Login/>}/> */}
        </>
      );
    }else{
        localStorage.clear();
        window.location.href = '/';
    }
    
  }
  
}

export default App;
